/**
 * `@visx/vendor/d3-time` (CommonJS)
 * See upstream license: https://github.com/d3/d3-time/blob/main/LICENSE
 *
 * This file only exists for tooling that doesn't work yet with package.json:exports
 * by proxying through the CommonJS version.
 */
module.exports = require('./vendor-cjs/d3-time/src/index.js');